module.exports = __webpack_public_path__ + "img/cleaning-gray.1f298f34.svg";